interface INamedReceiver {
  full_name?: string;
  first_name?: string;
  last_name?: string;
}

/**
 * Display name for a shift's professional from the raw API receiver:
 * prefer `full_name`, else join `first_name` + `last_name`, else undefined.
 */
export const getProfessionalName = (receiver?: INamedReceiver | null): string | undefined =>
  receiver?.full_name ||
  `${receiver?.first_name ?? ''} ${receiver?.last_name ?? ''}`.trim() ||
  undefined;
